module.exports = __webpack_public_path__ + "img/landingBackground.3914961b.png";